import { axiosApi } from "./axiosApi"

export const loginUser = async (credentials: {
  email: string
  password: string
}) => {
  const response = await axiosApi.post(
    "/api/auth/login",
    credentials
  )
  return response.data
}
